import {
    register,
    updateUser,
    updateActive,
    getUserList,
    getUserEditByID,
    getUserGroup,
    addUserGroup,
    preview,
    importStudent,
    editProfileByID,
    registerSendMail,
    moveUserToBin,
    getUserListBin,
    getUserActiveCalendar,
    putActiveAll,
    exportReport,
} from "@/service/account/manageUser";

import deleteUserGroupComponent from "@/views/user/dialog/manageGroupUser/manageGroupUser.vue";

import // getUserGroup,
    // getlistCompany,
    // getDetailCompany,
    "@/service/account/manageUserGroup";
import { uploadImage } from "@/service/upload/upload";
import UploadExcelComponent from "@/views/course/uploaduser.vue";
import downloadexcel from "vue-json-excel";
// import { loadCategory } from "@/service/category/category";
// import { loadSkill } from "@/service/skill/skill";
import XLSX from 'xlsx';
export default {
    components: {
        UploadExcelComponent,
        downloadexcel,
        deleteUserGroupComponent,
    },
    watch: {
        // selection(newValue) {
        //   this.onUpdate(newValue);
        // }
        searchdata(keyword) {
            this.searchInfo(keyword);
        },
        selectedRoleType(value) {
            console.log(value)
            if (value == "Learner") {

                this.viewStudent = false //ข้อมูลผู้ใช้
                this.insertStudent = false //เพิ่มรายชื่อ
                this.updateStudent = false //แก้ไขรายชื่อผู้ใช้
                this.activeStudent = false //ระงับการใช้งาน

                this.viewCourse = false //เข้าถึงคอร์ส
                this.insertCourse = false //เพิ่มคอร์ส
                this.updateCourse = false //แก้ไขคอร์ส
                this.activeCourse = false //ระงับคอร์ส

                this.manageCategory = false//จัดการ Category

                this.manageBanner = false//จัดการ banner

                this.viewReport = false //เข้าถึงการรายงาน

                this.userGroup = false //จัดการกลุ่มผู้ใช้

                this.adminCompany = false //อนุญาตให้เป็นแอดมิน
                this.notification = false //เข้าถึงเมนูส่งการแจ้งเตือน


                //new
                this.checkIsTeacher = false
                this.isTeacher = 'n'

            } else if (value == "Instructor") {

                this.viewStudent = true //ข้อมูลผู้ใช้
                this.insertStudent = false //เพิ่มรายชื่อ
                this.updateStudent = false //แก้ไขรายชื่อผู้ใช้
                this.activeStudent = false //ระงับการใช้งาน

                this.viewCourse = true //เข้าถึงคอร์ส
                this.insertCourse = true //เพิ่มคอร์ส
                this.updateCourse = true //แก้ไขคอร์ส
                this.activeCourse = true //ระงับคอร์ส

                this.manageCategory = false//จัดการ Category

                this.manageBanner = false//จัดการ banner

                this.viewReport = true //เข้าถึงการรายงาน

                this.userGroup = false //จัดการกลุ่มผู้ใช้

                this.adminCompany = false //อนุญาตให้เป็นแอดมิน
                this.notification = false //เข้าถึงเมนูส่งการแจ้งเตือน


                //new
                this.checkIsTeacher = true
                this.isTeacher = 'y' // เป็นผู้สอน, เข้า web admin ได้

            } else if (value == "Administrator") {

                this.viewStudent = true //ข้อมูลผู้ใช้
                this.insertStudent = true //เพิ่มรายชื่อ
                this.updateStudent = true //แก้ไขรายชื่อผู้ใช้
                this.activeStudent = true //ระงับการใช้งาน

                this.viewCourse = true //เข้าถึงคอร์ส
                this.insertCourse = true //เพิ่มคอร์ส
                this.updateCourse = true //แก้ไขคอร์ส
                this.activeCourse = true //ระงับคอร์ส

                this.manageCategory = true//จัดการ Category

                this.manageBanner = true//จัดการ banner

                this.viewReport = true //เข้าถึงการรายงาน

                this.userGroup = true //จัดการกลุ่มผู้ใช้

                this.adminCompany = true //อนุญาตให้เป็นแอดมิน
                this.notification = true //เข้าถึงเมนูส่งการแจ้งเตือน

                // new
                this.isTeacher = 'y' // เป็นผู้สอน, เข้า web admin ได้
                this.checkIsTeacher = true
            }
        }
    },
    data: function () {
        return {
            focus: "",
            type: "month",
            typeToLabel: {
                month: "Month",
                week: "Week",
                day: "Day",
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            colors: ["blue", "indigo", "deep-purple", "cyan", "teal", "green", "orange"],
            names: [
                "Meeting",
                "Holiday",
                "PTO",
                "Travel",
                "Event",
                "Birthday",
                "Conference",
                "Party",
            ],
            dialogMultiDelete: false,
            dialogMultiRecover: false,
            dialogMultiDeleteSuccess: false,
            dialogMultiRecoverSuccess: false,
            loadingDelete: false,
            loadingRecover: false,
            dialogRecycleBin: false,
            dialogRecover: false,
            dialogDelete: false,
            disabledCount: 0,
            usersBin: [],
            selectUsers: [],
            selectUsersBin: [],
            actionUsersBin: [],
            pageCountBin: 0,
            alert: false,
            valid: false,
            tab: 0,
            dialogRequestTutor: false,
            dialogFormUser: false,
            dialogGroupUser: false,
            dialogStatus: false,
            dialogStatusActive: false,
            dialogSuccess: false,
            filterdialog: false,
            deleteDialog: false,
            dialogAddSuccess: false,
            dialogAddFail: false,
            dialogAddMetaDataFail: false,
            dialogEditSuccess: false,
            dialogUserGroupSuccess: false,
            dialogEditFail: false,
            dialogUsernameDuplicade: false,
            isEdit: false,
            formDisabled: false,
            checkboxPassword: false,
            checkboxPasswordHide: true,
            showPassword: false,
            showConFirmPassword: false,

            permissionStudentAll: false,
            permissionCourseAll: false,

            viewStudent: false, //ข้อมูลผู้ใช้
            insertStudent: false, //เพิ่มรายชื่อ
            updateStudent: false, //แก้ไขรายชื่อผู้ใช้
            activeStudent: false, //ระงับการใช้งาน

            checkIsTeacher: false,
            isTeacher: "n",

            viewCourse: false, //เข้าถึงคอร์ส
            insertCourse: false, //เพิ่มคอร์ส
            updateCourse: false, //แก้ไขคอร์ส
            activeCourse: false, //ระงับคอร์ส
            manageCategory: false, //จัดการ Category
            manageBanner: false, //จัดการ Banner
            viewReport: false, //เข้าถึงการรายงาน
            userGroup: false, //จัดการกลุ่มผู้ใช้

            adminCompany: false,
            notification: false,

            pageUserUploadCount: 0,
            pageUserUpload: 1,
            // itemsPerPageUserUpload: 10,
            // itemsPerPageUser: 10,
            excelFile: "",
            // template_password:
            //   "https://s3-amr.deknerd.com/template/template-user/template-import-user-password-optional.xlsx",
            // template:
            //   "https://s3-amr.deknerd.com/template/template-user/template-import-user-optional.xlsx",
            template_password:
                "https://s3-amr.deknerd.com/template/exam/template-import-user-password-v3.xlsx",
            template:
                "https://s3-amr.deknerd.com/template/exam/template-import-user-optional-v3.xlsx",
            showExampleTable: true,
            showTabsResult: false,
            tabResult: "success",
            userUploadFail: [],
            userUploadRepeat: [],
            userUploadSuccess: [],

            isSuccessTab: true,

            //file
            tableData: [],

            resultPermission: {},
            editUser: {},
            loading: true,
            imgPreview: "",
            imageFile: null,
            imageReady: false,
            users: [],
            groupUsers: [],
            filterGroupResult: [],
            selectionGroup: [],
            selection: [],
            filterGroup: "",
            company: "",

            userGroupSearch: [],
            userSort: [],
            userGroupSearch2: [],
            userGroupAllAtIndex: [],

            imageRules: [
                (v) => !!v || "กรุณาเลือกอัปโหลดรูปภาพ",
                (v) => v.size < 20000000 || "กรุณาเลือกไฟล์ที่มีขนาดน้อยกว่า 20 MB",
            ],

            idCardNumberRules: [(v) => !!v || "กรุณากรอกเลขบัตรประจำตัวประชาชน"],
            searchby: "ทั้งหมด",
            searchType: ["ทั้งหมด", "เปิดการใช้งาน", "ปิดการใช้งาน"],
            sortType: ["เวลา สูง-ต่ำ", "เวลา ต่ำ-สูง", "ยอดนิยม สูง-ต่ำ", "ยอดนิยม ต่ำ-สูง"],
            status_toggle: 0,

            editUserId: "",
            prefixName: "",
            firstName: "",
            lastName: "",
            prefixNameEng: "",
            firstNameEng: "",
            lastNameEng: "",
            school: "",
            idCardNumber: "",
            selectedGender: null,
            email: "",
            username: "",
            password: "",
            conFirmPassword: "",
            image: "",
            searchdata: "",
            sortData: "",
            searchUser: null,
            pageCount: 1,
            pageCount2: 1,
            pageCount3: 1,
            limit: 10,
            searchStudent: null,
            group: [],
            arrayGroup: [],
            arraySort: ["Name", "Email", "Username", "Organization"],
            arrayTypeOfUser: [{ title: "Learner", value: 'n' }, { title: "Instructor", value: 'y' }, { title: "Administrator", value: 'admin' }],
            arraySortBy: ["Ascending", "Descending"],
            sortUser: null,
            sortUserBy: null,
            roleTypeFilter: null,
            // category: [],
            skill: [],
            selectedGroup: [],
            selectedCategory: [],
            indexSelectByAdmin: 0,
            active: "null",
            params: {},
            page: 1,
            page2: 1,
            page3: 1,
            deleteItemID: [],
            indexItem: null,
            oldDetailUser: null,
            excelDialog: false,
            fileExcelName: "รายชื่อผู้ใช้งาน.xls",
            // prefix firstName lastName  gender username temppassword email organization
            json_fields: {

                prefix: "prefix",
                firstName: "firstName",
                lastName: "lastName",
                gender: {
                    field: "gender",
                    callback: (gender) => {
                        return gender === "male" ? "ชาย" : gender === "female" ? "หญิง" : "-";
                    },
                },
                username: "username",
                temppassword: "temppassword",
                email: "email",

                note: "school",
            },
            successUpload: true,
            fix_password: "custom",
            send_email: "true",
            dialogSendmail: false,

            //dialog
            rejectDialog: false,
            wrongTemplateDialog: false,
            passwordLessthanDialog: false,
            delete_dialog: false,
            pageGroupLength: 1,
            pageGroupImport: 1,
            pageGroupImportLength: 1,
            snackbar: false,
            vertical: true,
            arrIdGroup: [],
            arrayGroupTitle: [],
            arrayGroupTitleRepeat: [],
            arrWrongGroup: [],
            arrWrongGroupRepeat: [],
            canImporting: false,
            canImporting2: true,
            dialogStatusActiveUsers: false,
            arrMetaData: [],
            arrFeildHeader: [],
            countHeader: null,
            actionUser: [],
            dialogCalendar: false,
            student: [],
            eventsUser: [],
            selectedRoleType: null,
            roleType: ["Learner", "Instructor", "Administrator"],
            type_toggle: 3,
            description: null,
            loadingReturn: false,
            arrayGroup2: [],
        };
    },
    computed: {
        conFirmPasswordRules() {
            const rules = [];
            if (this.password) {
                const rule = (v) =>
                    (!!v && v) === this.password ||
                    this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.confirmPasswordRules"
                    );
                rules.push(rule);
            }
            return rules;
        },
        cantImport() {
            // !(userUploadSuccess.length == 0 || userUploadRepeat.length == 0) || userGroupSearch2.length == 0
            // // console.log(this.userGroupSearch2);
            if (this.userUploadSuccess.length > 0) {
                // // console.log("don't select User group");
                return true;
            } else if (this.successUpload === false) {
                // // console.log(this.successUpload);
                return true;
            } else if (this.userUploadSuccess.length > 0) {
                return false;
            } else if (this.userUploadRepeat.length > 0) {
                return false;
            }
            return true;
        },

        groupRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.groupRules"),
            ];
        },
        nameRules() {
            return [
                (v) =>
                    !!v || this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.nameRules"),
            ];
        },
        genderRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.genderRules"),
            ];
        },
        prefixNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.prefixRules"),
            ];
        },
        firstNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.firstNameRules"),
            ];
        },
        lastNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.lastNameRules"),
            ];
        },

        prefixNameEngRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.prefixEngRules"),
            ];
        },
        firstNameEngRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.firstNameEngRules"
                    ),
            ];
        },
        lastNameEngRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.lastNameEngRules"),
            ];
        },

        passwordRules() {
            return [
                (v) =>
                    v.length >= 8 ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.passwordRules"),
            ];
        },

        emailRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.emailRule1"),
                (v) =>
                    /.+@.+\..+/.test(v) ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.emailRule2"),
            ];
        },

        userNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.userNameRules"),
            ];
        },

        selectedGroups() {
            return this.$vuetify.lang.t(
                "$vuetify.learnerManagement.learnerList.selectedGroups"
            );
        },
        genders() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.male"),
                    value: "male",
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.female"),
                    value: "female",
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.notSpecified"
                    ),
                    value: null,
                },
            ];
        },
        headers() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.photo"),
                    align: "center",
                    sortable: false,
                    value: "image",
                },
                // {
                //   text: this.$vuetify.lang.t(
                //     "$vuetify.learnerManagement.learnerList.prefix"
                //   ),
                //   value: "prefixName",
                //   align: "start",
                //   sortable: false,
                // },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.name"),
                    value: "fullName",
                    align: "start",
                    sortable: false,
                    width: "200",
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.username"),
                    value: "username",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.email"),
                    value: "email",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.organization"
                    ),
                    value: "school",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.group"),
                    value: "group",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.roleType"),
                    value: "role",
                    align: "center",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.status"),
                    value: "active",
                    align: "start",
                    sortable: false,
                },
                {
                    text: "ACTIVE",
                    value: "online",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "",
                    value: "actions",
                    align: "start",
                    sortable: false,
                },
            ];
        },
        headersBin() {
            return [
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.photo"),
                    align: "center",
                    sortable: false,
                    value: "image",
                },
                // {
                //   text: this.$vuetify.lang.t(
                //     "$vuetify.learnerManagement.learnerList.prefix"
                //   ),
                //   value: "prefixName",
                //   align: "start",
                //   sortable: false,
                // },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.name"),
                    value: "fullName",
                    align: "start",
                    sortable: false,

                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.email"),
                    value: "email",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.username"),
                    value: "username",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.organization"
                    ),
                    value: "school",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.group"),
                    value: "group",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t("$vuetify.learnerManagement.learnerList.roleType"),
                    value: "role",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "",
                    value: "actions",
                    align: "start",
                    sortable: false,
                },
            ];
        },

        tableHeader() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.prefix"
                    ),
                    value: "prefix",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.firstName"
                    ),
                    value: "firstname",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.lastName"
                    ),
                    value: "lastname",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.gender"
                    ),
                    value: "gender",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.username"
                    ),
                    value: "username",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.email"
                    ),
                    value: "contactEmail",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.note"
                    ),
                    value: "note",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.group"
                    ),
                    value: "usergroups",
                    sortable: false,
                    align: "start",
                },
                // {
                //   text: "Additional Info",
                //   value: "metadata",
                //   sortable: false,
                // },
            ];
        },
        tableHeader_password() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.prefix"
                    ),
                    value: "prefix",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.firstName"
                    ),
                    value: "firstname",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.lastName"
                    ),
                    value: "lastname",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.gender"
                    ),
                    value: "gender",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.username"
                    ),
                    value: "username",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.password"
                    ),
                    value: "password",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.email"
                    ),
                    value: "contactEmail",
                    sortable: false,
                },

                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.note"
                    ),
                    value: "note",
                    sortable: false,
                },

                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.importUsersDialog.group"
                    ),
                    value: "usergroups",
                    sortable: false,
                    align: "start",
                },
                // {
                //   text: "Additional Info",
                //   value: "metadata",
                //   sortable: false,
                // },
            ];
        },
        tableHeaderGroup() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.headerTableGroup.group"
                    ),
                    value: "title",
                    sortable: false,
                    align: "start",
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.headerTableGroup.ID"
                    ),
                    value: "_id",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "",
                    value: "action",
                    sortable: false,
                    align: "center",
                },
            ];
        },
    },

    mounted() {
        console.log("mount users");
        this.initialize();
        this.$refs.calendar.checkChange();
    },

    methods: {
        viewDay({ date }) {
            this.focus = date;
            this.type = "day";
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = "";
        },
        async prev() {
            await this.$refs.calendar.prev();

            let paramsCalendar = {
                idstudent: this.student.id,
                month: this.$refs.calendar.lastStart.month,
                year: this.$refs.calendar.lastStart.year,
            };
            let result = await getUserActiveCalendar(paramsCalendar);

            this.eventsUser = [];
            let arrEvent = [];
            result.forEach((event) => {
                if (event.arrayCourseDay.length) {
                    event.arrayCourseDay.forEach((eventCourse, index) => {
                        let time = eventCourse.endTime - eventCourse.startTime;
                        let second = time / 1000;
                        // console.log(second);
                        arrEvent.push({
                            // timed: second >= 120 ? true : false,
                            timed: true,
                            color: this.colors[index] ? this.colors[index] : 'grey darken-1',
                            name: eventCourse.title,
                            start: new Date(eventCourse.startTime),
                            end: new Date(eventCourse.endTime),
                        });
                    });
                }
            });
            this.eventsUser = arrEvent;
        },
        async next() {
            await this.$refs.calendar.next();
            let paramsCalendar = {
                idstudent: this.student.id,
                month: this.$refs.calendar.lastStart.month,
                year: this.$refs.calendar.lastStart.year,
            };
            let result = await getUserActiveCalendar(paramsCalendar);

            this.eventsUser = [];
            let arrEvent = [];
            result.forEach((event) => {
                if (event.arrayCourseDay.length) {
                    event.arrayCourseDay.forEach((eventCourse, index) => {
                        let time = eventCourse.endTime - eventCourse.startTime;
                        let second = time / 1000;
                        // console.log(second);
                        arrEvent.push({
                            // timed: second >= 120 ? true : false,
                            timed: true,
                            color: this.colors[index] ? this.colors[index] : 'grey darken-1',
                            name: eventCourse.title,
                            start: new Date(eventCourse.startTime),
                            end: new Date(eventCourse.endTime),
                        });
                    });
                }
            });

            this.eventsUser = arrEvent;
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                setTimeout(() => {
                    this.selectedOpen = true;
                }, 10);
            };

            if (this.selectedOpen) {
                this.selectedOpen = false;
                setTimeout(open, 10);
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        async openCalendar(item) {
            this.dialogCalendar = true;

            this.student = item;
            await this.getUserActiveCalendar();
            console.log(this.$refs.calendar);
        },
        closeCalendar() {
            this.dialogCalendar = false;
            this.type = "month";
            this.type_toggle = 3;
            this.setToday();
        },
        setTypeCalendar() {
            switch (this.type_toggle) {
                case 0:
                    this.setToday();
                    break;
                case 1:
                    this.type = 'day';
                    break;
                case 2:
                    this.type = 'week';
                    break;
                case 3:
                    this.type = 'month';
                    break;
            }
        },
        async getUserActiveCalendar() {
            let date = new Date();
            let month = date.getMonth();
            let year = date.getFullYear();
            console.log(date, " // ", month, " // ", year);
            let paramsCalendar = {
                idstudent: this.student.id,
                month: month + 1,
                year: year,
            };
            let result = await getUserActiveCalendar(paramsCalendar);
            console.log(result);
            let arrEvent = [];
            this.eventsUser = [];
            result.forEach((event) => {
                if (event.arrayCourseDay.length) {
                    event.arrayCourseDay.forEach((eventCourse, index) => {
                        let time = eventCourse.endTime - eventCourse.startTime;
                        let second = time / 1000;
                        // console.log(second);
                        arrEvent.push({
                            // timed: second >= 120 ? true : false,
                            timed: true,
                            color: this.colors[index] ? this.colors[index] : "grey darken-1",
                            name: eventCourse.title,
                            start: new Date(eventCourse.startTime),
                            end: new Date(eventCourse.endTime),
                        });
                    });
                }
            });
            console.log(arrEvent);
            this.eventsUser = arrEvent;
        },
        async initialize() {
            this.paramsG = {
                search: null,
                sort: "created_at",
                sortby: -1,
                usergroup: null,
                page: 1,
                limit: 1000,
                active: "null",
            };
            this.params = {
                adminCompany: null,
                isTeacher: null,
                search: null,
                sort: "created_at",
                sortby: 1,
                usergroup: null,
                page: 1,
                limit: 10,
                active: "null",
                groupnull: false,
            };
            this.paramsUserGroup = {
                adminCompany: null,
                isTeacher: null,
                search: null,
                sort: "created_at",
                sortby: 1,
                usergroup: null,
                page: 1,
                limit: 10,
                active: "null",
            };
            this.paramsBin = {
                search: null,
                sort: "created_at",
                sortby: 1,
                usergroup: null,
                page: 1,
                limit: 10,
                active: "null",
            };

            if (!this.$store.state.permission.viewStudent) {
                this.noPermission();
            } else {
                await this.getUserGroupList();
                await this.getUserList();
                await this.getUserListBin();
                // await this.getUserGroupForFilter();
            }

            this.loading = false;
            this.status_toggle = 0;
            this.userGroupSearch = [];
            this.userSort = [];
            this.userSortBy = [];
            this.sortUser = null;
            this.sortUserBy = null;
            this.selectedGroup = [];
            this.selectedCategory = [];
            this.active = "null";
            this.filterdialog = false;
            this.searchdata = "";
            this.roleTypeFilter = null;
        },
        searchInfo(keyword) {
            this.params.search = keyword;
            this.params.page = 1;
            this.page = 1;
            this.getUserList();
        },

        closeAddingNewUser() {
            this.clearForm();
        },

        addRowData() {
            this.arrMetaData.push({
                key: "",
                value: "",
            });
        },

        async confirmDeleteRowData(item) {
            let index = this.arrMetaData.indexOf(item);
            this.arrMetaData.splice(index, 1);
        },

        // onUpdate(selectionGroup) {
        //   // console.log("selectionGroup", selectionGroup);
        // },
        async changePage(page) {
            this.params.page = page;
            await this.getUserList();
        },
        async changePageBin(page) {
            this.paramsBin.page = page;
            await this.getUserListBin();
        },
        async changePageGroupImport(page) {
            this.pageGroupImport = page;
            await this.getUserGroupList();
        },
        copyToClipBoard(item) {
            navigator.clipboard.writeText(item._id);
            this.snackbar = true;
        },

        selectAllToggle(props) {
            if (this.selectUsers.length != this.users.length - this.disabledCount) {
                // console.log("if");
                this.selectUsers = [];
                const self = this;
                props.items.forEach((item) => {
                    // if (item.active == false) {
                    self.selectUsers.push(item);
                    // }
                });
            } else {
                // console.log("else");
                this.selectUsers = [];
            }
        },

        selectAllToggleBin(props) {
            if (this.selectUsersBin.length != this.users.length - this.disabledCount) {
                // console.log("if");
                this.selectUsersBin = [];
                const self = this;
                props.items.forEach((item) => {
                    if (item.active == false) {
                        self.selectUsersBin.push(item);
                    }
                });
            } else {
                // console.log("else");
                this.selectUsersBin = [];
            }
        },

        cancelSelect() {
            // this.select();
            this.selectUsers = [];
        },
        cancelSelectBin() {
            // this.select();
            this.selectUsersBin = [];
            this.actionUsersBin = [];
        },
        confirmDelete(item) {
            this.actionUser = item;

            console.log(this.actionUser);
            this.dialogDelete = true;
        },
        async deleteCourse() {
            let arraystudent = [];
            this.loadingDelete = true;
            if (this.actionUser.active == true) {
                this.updateActiveId = this.actionUser.id;
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: false,
                });
            }
            arraystudent.push({ id: this.actionUser.id });
            console.log(arraystudent);

            let result = await moveUserToBin({
                arraystudent,
                istrash: true,
            });
            let resultActive = await putActiveAll({
                arraystudent: arraystudent,
                active: false,
            });

            this.loadingDelete = false;
            this.dialogDelete = false;
            this.dialogMultiDeleteSuccess = true;

            this.actionUser = [];
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },
        confirmMultiDelete() {
            // console.log(this.selectUsers);
            this.dialogMultiDelete = true;
        },
        confirmRecover(item) {
            this.actionUsersBin = item;

            // console.log(this.actionUsersBin);
            this.dialogRecover = true;
        },
        confirmMultiRecover(item) {
            if (item != null) {
                this.actionUsersBin = item;
            }
            // console.log(this.selectUsersBin);
            // console.log(this.actionUsersBin);
            this.dialogMultiRecover = true;
        },
        async deleteMultiUsers() {
            let arraystudent = [];
            for (let i in this.selectUsers) {
                this.loadingDelete = true;
                // if (this.selectUsers[i].active == false) {
                    arraystudent.push({ id: this.selectUsers[i].id });
                // }
            }

            let result = await moveUserToBin({
                arraystudent,
                istrash: true,
            });
            let resultActive = await putActiveAll({
                arraystudent: arraystudent,
                active: false,
            });

            this.loadingDelete = false;
            this.dialogMultiDelete = false;
            this.dialogMultiDeleteSuccess = true;

            this.selectUsers = [];
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },

        async recoverUser() {
            let arraystudent = [];
            // for (let i in this.actionUsersBin) {
            this.loadingRecover = true;
            if (this.actionUsersBin.active == false) {
                arraystudent.push({ id: this.actionUsersBin.id });
            }
            // }



            let result = await moveUserToBin({
                arraystudent,
                istrash: false,
            });
            let resultActive = await putActiveAll({
                arraystudent: arraystudent,
                active: true,
            });

            this.loadingRecover = false;
            this.dialogRecover = false;
            this.dialogMultiRecoverSuccess = true;

            this.actionUsersBin = [];
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },

        async recoverMultiUser() {
            let arraystudent = [];
            if (this.actionUsersBin) {
                // for (let i in this.actionUsersBin) {
                this.loadingRecover = true;
                if (this.actionUsersBin.active == false) {
                    arraystudent.push({ id: this.actionUsersBin.id });
                }
                // }
            }
            if (this.selectUsersBin) {
                // console.log(this.selectUsersBin);
                for (let i in this.selectUsersBin) {
                    this.loadingRecover = true;
                    if (this.selectUsersBin[i].active == false) {
                        arraystudent.push({ id: this.selectUsersBin[i].id });
                    }
                }
            }


            let result = await moveUserToBin({
                arraystudent,
                istrash: false,
            });
            let resultActive = await putActiveAll({
                arraystudent: arraystudent,
                active: true,
            });

            this.loadingRecover = false;
            this.dialogMultiRecover = false;
            this.dialogMultiRecoverSuccess = true;

            this.selectUsersBin = [];
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },

        closeDialogRecover() {
            this.dialogMultiRecoverSuccess = false;
            this.dialogRecycleBin = false;
        },

        async openRecycleBin() {
            this.dialogRecycleBin = true;
            await this.getUserListBin();
        },

        async getUserListBin() {
            let result = await getUserListBin(this.paramsBin);
            // console.log(result);
            this.usersBin = [];
            // (this.pageCount = Math.ceil(result.data.length / this.limit)),
            this.pageCountBin = result.maxPage;
            await result.data.forEach(async (user) => {
                this.usersBin.push({
                    id: user._id,
                    image: user.image,
                    prefixName: user.prefix,
                    fullName: user.prefix
                        ? user.prefix + " " + user.firstName + " " + user.lastName
                        : user.firstName + " " + user.lastName,
                    email: user.email,
                    school: user.school,
                    username: user.username,
                    course: {
                        buy: user.countBuyCourse,
                        create: user.countCourseCreate,
                    },
                    active: user.active,
                    // group: user.user_groups
                    group: await this.showGroupList(user.user_groups),
                    role: await this.getRole({ ...user.permission, isTeacher: user.isTeacher })
                });
            });

            let requestArr = this.$store.state.requestData;
            await requestArr.forEach((request) => {
                this.usersBin.forEach((course, index) => {
                    if (request._id == course.id) {
                        this.usersBin[index] = {
                            ...course,
                            learnerRequest: request.totalLearner,
                        };
                    }
                });
            });
        },

        async closeDialogRecycleBin() {
            this.dialogRecycleBin = false;
            await this.getUserList();
        },

        removeByUser(item) {
            const index = this.selection.indexOf(item._id);
            if (index >= 0) this.selection.splice(index, 1);
        },
        removeFilter(item) {
            const index = this.userGroupSearch.indexOf(item._id);
            const index1 = this.userSort.indexOf(item);
            if (index >= 0) this.userGroupSearch.splice(index, 1);
            if (index1 >= 0) this.userSort.splice(index, 1);
        },
        removeFilter2(item) {
            const index = this.userGroupSearch2.indexOf(item._id);
            if (index >= 0) this.userGroupSearch2.splice(index, 1);
        },
        changeState() {
            this.insertStudent = false; //เพิ่มรายชื่อ
            this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
            this.activeStudent = false; //ระงับการใช้งาน
        },

        changeStateUpdate() {
            if (this.insertStudent == false && this.updateStudent == false) {
                this.activeStudent = false; //ระงับการใช้งาน
            }
        },

        changeStateCourse() {
            this.insertCourse = false; //เพิ่มคอร์ส
            this.updateCourse = false; //แก้ไขคอร์ส
            this.activeCourse = false; //ระงับคอร์ส
        },

        changeStateUpdateCourse() {
            if (this.insertCourse == false && this.updateCourse == false) {
                this.activeCourse = false; //ระงับคอร์ส
            }
        },

        openDialogStatusUsers() {
            this.dialogStatusActiveUsers = true;
        },

        // onSort() {
        //   let index = this.sortType.indexOf(this.sortData);

        //   this.params.sortby = index % 2 == 0 ? -1 : 1;
        //   this.params.sort = index < 2 ? "created_at" : "countMylib";

        //   // this.getCourseList();
        // },
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;
            if (isLt1M) {
                return true;
            }
            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning",
            });
            return false;
        },
        handleSuccess({ header, file }, results) {
            this.tableData = [];
            this.loading = false;
            
            if(this.fix_password == "custom"){
                let found = header.find(field => field == "password")
                if(!found){
                    //Open dialog wrong template
                    this.wrongTemplateDialog = true
                    return 
                }
                const findLessthan = results.findIndex(student=> student.username.length>0 && student.password.length<8)
                if(findLessthan> -1){
                    this.passwordLessthanDialog = true
                    return
                }
            }


            results.forEach(rs => {
                if (rs.password) {
                    this.tableData.push({
                        prefix: rs.prefix,
                        firstname: rs.firstname,
                        lastname: rs.lastname,
                        gender: rs.gender,
                        username: rs.username,
                        password: rs.password,
                        contactEmail: rs.contactEmail,
                        note: rs.note,
                        usergroups: rs.usergroups,
                    });
                } else {
                    this.tableData.push({
                        prefix: rs.prefix,
                        firstname: rs.firstname,
                        lastname: rs.lastname,
                        gender: rs.gender,
                        username: rs.username,
                        contactEmail: rs.contactEmail,
                        note: rs.note,
                        usergroups: rs.usergroups,
                    });
                }

            });


            this.tableData = results;
            console.log("handleSuccess -> this.tableData", this.tableData)


            var valueArr = results.map(function (item) {
                return item.contactEmail;
            });
            var isDuplicate = valueArr.some(function (item, idx) {

                return valueArr.indexOf(item) != idx;
            });

            if (isDuplicate) {
                console.log(isDuplicate)
                this.rejectDialog = true;
            } else {
                this.previewImportStudent(results, header);
            }

        },
        async preview() {
            if (this.imageFile != null) {
                this.imgURL = await this.uploadImg(this.imageFile);
                this.imgPreview = this.imgURL;
                this.imageReady = true;
            } else {
                this.imageReady = false;
            }
        },
        async uploadImg(image) {
            let status = await uploadImage("user", image);
            return status;
        },

        async getUserGroupForFilter() {
            let result = await getUserGroup(this.paramsUserGroup);
            this.filterGroupResult = await result.filter((group) => group.active === true);
        },

        refreshFilter() {
            this.initialize();
        },

        async applyFilter() {
            this.params.usergroup = [];
            this.params.sort = null;
            this.params.sortby = null;
            this.page = 1;
            this.params.groupnull = false;
            if (this.status_toggle == 1) {
                this.params.active = true;
                this.params.page = this.page;
                // this.params.usergroup = await this.userGroupSearch;
                this.userGroupSearch.forEach(group => {
                    if (group._id != '') {
                        this.params.usergroup.push(group._id);
                    }
                    else {
                        this.params.groupnull = true;
                    }
                });
                switch (this.sortUser) {
                    case "Name":
                        this.params.sort = await "firstName";
                        break;
                    case "Email":
                        this.params.sort = await "email";
                        break;
                    case "Username":
                        this.params.sort = await "username";
                        break;
                    case "Organization":
                        this.params.sort = await "school";
                        break;
                }
                switch (this.sortUserBy) {
                    case "Ascending":
                        this.params.sortby = await 1;
                        break;
                    case "Descending":
                        this.params.sortby = await -1;
                        break;
                }
                // await this.getUserList();
                // console.log("if");
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.params.page = this.page;
                this.params.groupnull = false;
                // this.params.usergroup = await this.userGroupSearch;
                this.userGroupSearch.forEach(group => {
                    if (group._id != '') {
                        this.params.usergroup.push(group._id);
                    }
                    else {
                        this.params.groupnull = true;
                    }
                });
                switch (this.sortUser) {
                    case "Name":
                        this.params.sort = await "firstName";
                        break;
                    case "Email":
                        this.params.sort = await "email";
                        break;
                    case "Username":
                        this.params.sort = await "username";
                        break;
                    case "Organization":
                        this.params.sort = await "school";
                        break;
                }
                switch (this.sortUserBy) {
                    case "Ascending":
                        this.params.sortby = await 1;
                        break;
                    case "Descending":
                        this.params.sortby = await -1;
                        break;
                }
                // await this.getUserList();
                // console.log("else if");
            } else {
                this.params.active = "null";
                this.params.page = this.page;
                this.params.groupnull = false;
                // this.params.usergroup = await this.userGroupSearch;
                this.userGroupSearch.forEach(group => {

                    if (group._id != '') {
                        this.params.usergroup.push(group._id);
                    }
                    else {
                        this.params.groupnull = true;
                    }
                });
                switch (this.sortUser) {
                    case "Name":
                        this.params.sort = await "firstName";
                        break;
                    case "Email":
                        this.params.sort = await "email";
                        break;
                    case "Username":
                        this.params.sort = await "username";
                        break;
                    case "Organization":
                        this.params.sort = await "school";
                        break;
                }
                switch (this.sortUserBy) {
                    case "Ascending":
                        this.params.sortby = await 1;
                        break;
                    case "Descending":
                        this.params.sortby = await -1;
                        break;
                }
                // console.log(this.userGroupSearch);

                // if(this.roleTypeFilter == 'admin'){
                //   this.params.isTeacher = null
                //   this.params.adminCompany = true
                // } else {
                // this.params.isTeacher = this.roleTypeFilter
                // }

                // await this.getUserList();
                // console.log("else");
            }
            this.params.isTeacher = this.roleTypeFilter;
            await this.getUserList();

            // if (this.searchby == "เปิดการใช้งาน") {
            //   this.params.active = true;
            //   this.params.usergroup = await this.userGroupSearch;
            //   await this.getUserList();
            // } else if (this.searchby == "ปิดการใช้งาน") {
            //   this.params.active = false;
            //   this.params.usergroup = await this.userGroupSearch;
            //   await this.getUserList();
            // } else {
            //   this.params.active = "null";
            //   this.params.usergroup = await this.userGroupSearch;
            //   // console.log(this.userGroupSearch);
            //   await this.getUserList();
            // }
        },

        validationForm() {
            if (
                this.prefixName != "" &&
                this.lastName != "" &&
                this.username != "" &&
                this.email != ""
            ) {
                this.valid = true;
            }
            return this.valid;
        },

        openModalStatus(item) {
            let index = this.users.indexOf(item);
            this.indexItem = index;
            if (this.users[index].active == true) {
                this.dialogStatus = true;
                this.updateActiveId = this.users[index].id;
                this.updateActive = this.users[index].active;
            } else {
                this.dialogStatusActive = true;
                this.updateActiveId = this.users[index].id;
                this.updateActive = this.users[index].active;
            }
        },
        cancelStatus() {
            this.dialogStatus = false;
            this.users[this.indexItem].active = this.updateActive;
        },
        cancelStatusActive() {
            this.dialogStatusActive = false;
            this.users[this.indexItem].active = this.updateActive;
        },

        async getUserList() {
            this.loading = true;
            // localStorage.removeItem("editCourseID");
            // console.log(this.params);
            let result = await getUserList(this.params);
            this.users = [];
            // this.pageCount = Math.ceil(result.length / this.limit)
            this.pageCount = result.maxPage;
            await result.data.forEach(async (user) => {
                this.users.push({
                    id: user._id,
                    image: user.image,
                    fullName: user.prefix
                        ? user.prefix + " " + user.firstName + " " + user.lastName
                        : user.firstName + " " + user.lastName,
                    email: user.email,
                    school: user.school,
                    username: user.username,
                    lastday: user.lastday,
                    lastdayTimestamp: parseInt(user.lastdayTimestamp),
                    activeDay: await this.getDifferentDay(parseInt(user.lastdayTimestamp)),
                    course: {
                        buy: user.countBuyCourse,
                        create: user.countCourseCreate,
                    },
                    active: user.active,
                    // group: user.user_groups
                    group: await this.showGroupList(user.user_groups),
                    role: await this.getRole({ ...user.permission, isTeacher: user.isTeacher })
                });
            });
            // console.log("list user : ", this.users);
            this.imageReady = true;
            this.loading = false;
        },
        async getDifferentDay(timeStamp) {
            let nowDate = new Date().toISOString();
            let day_now = new Date(nowDate).getTime();
            // console.log(day_now, timeStamp, day_now - timeStamp);
            let day_active = timeStamp;
            let arrActive = [];

            var diffInMs = day_now - day_active;

            var diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            var diffInDay = diffInMs % (1000 * 60 * 60 * 24);

            var diffInHrs = diffInDay / (1000 * 60 * 60);
            var diffInHr = diffInDay % (1000 * 60 * 60);

            var diffInMins = diffInHr / (1000 * 60);
            var diffInMin = diffInHr % (1000 * 60);

            var diffInSecs = diffInMin / 1000;

            if (timeStamp == -1) {
                arrActive.push({
                    diffInDays: 0,
                    diffInHrs: 0,
                    diffInMins: 0,
                    diffInSecs: 0,
                });
            } else if (timeStamp) {
                arrActive.push({
                    diffInDays: diffInDays.toFixed(),
                    diffInHrs: diffInHrs.toFixed(),
                    diffInMins: diffInMins.toFixed(),
                    diffInSecs: diffInSecs.toFixed(),
                });
            } else {
                arrActive.push({
                    diffInDays: -9999,
                    diffInHrs: -9999,
                    diffInMins: -9999,
                    diffInSecs: -9999,
                });
            }

            return arrActive;
        },
        async showGroupList(userGroup) {
            let userGroupOutput = [];
            await userGroup.forEach(
                async (grouplist) =>
                    await this.arrayGroup.forEach(async (group) =>
                        group._id == grouplist._id ? await userGroupOutput.push(group) : null
                    )
            );
            return userGroupOutput;
        },
        async getUserGroupList() {
            let result = await getUserGroup(this.paramsG);
            // console.log(result);
            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            this.arrayGroup2 = [];
            this.arrayGroup2.push({
                title: 'ไม่มีกลุ่ม',
                _id: ''
            });
            await result.forEach(async (group) => {
                // let arrayGroup = []
                group.child_User_Group.length === 0
                    ? await this.arrayGroup.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.arrayGroup.push({
                            title: group.title + " -> " + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.arrayGroup.push({
                            title: group.title + " -> " + child.title + " -> " + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
                // await userGroupAllAtIndex.push({arrayGroup})
            });
            // console.log(this.arrayGroup);
            this.groupUsers = result;
            await this.arrayGroup.filter((group) => group.active === true);
            this.arrayGroup.forEach(element => {
                this.arrayGroup2.push(element);
            });

            // this.filterGroupResult = result;
        },

        async getUserGroup(item) {
            this.dialogGroupUser = true;
            this.editUserId = item.id;
            let index = this.users.indexOf(item);

            if (this.editUserId) {
                this.selection = this.users[index].group.map((group) => group._id);
            }
        },

        async getUserEdit(item) {
            this.arrMetaData = [];
            let result = await getUserEditByID({
                idstudent: item.id,
            });
            console.log(result)
            if (result.metaData) {
                result.metaData.forEach((data) => {
                    this.arrMetaData.push({
                        key: data.key,
                        value: data.value,
                    });
                });
            }
            if (result.localizations && result.localizations.length) {
                this.prefixNameEng = result.localizations[1].prefix;
                this.firstNameEng = result.localizations[1].firstName;
                this.lastNameEng = result.localizations[1].lastName;
            } else {
                this.prefixNameEng = result.prefix;
                this.firstNameEng = result.firstName;
                this.lastNameEng = result.lastName;
            }

            this.oldDetailUser = result;
            this.editUserId = item.id;
            this.editUserCompanies = result.companies[0];
            this.imgPreview = result.image;
            this.imageReady = true;
            this.selection = result.user_groups;
            this.description = result.description;
            let gen = this.genders.filter((gender) => gender.value == result.gender);
            if (gen.length > 0) {
                this.selectedGender = gen[0].value;
            } else {
                this.selectedGender = null;
            }
            this.prefixName = result.prefix;
            this.firstName = result.firstName;
            this.lastName = result.lastName;

            this.school = result.school ? result.school : "";
            this.idCardNumber = result.identificationNumber;
            this.email = result.email;
            this.username = result.username;

            if (result.isTeacher == "y") {
                this.checkIsTeacher = true;
            } else {
                this.checkIsTeacher = false;
            }

            //permission//
            // this.resultPermission = result.permission;
            // this.viewStudent = result.permission.viewStudent; //ข้อมูลผู้ใช้
            // this.insertStudent = result.permission.insertStudent; //เพิ่มรายชื่อ
            // this.updateStudent = result.permission.updateStudent; //แก้ไขรายชื่อผู้ใช้
            // this.activeStudent = result.permission.activeStudent; //ระงับการใช้งาน

            // this.viewCourse = result.permission.viewCourse; //เข้าถึงคอร์ส
            // this.insertCourse = result.permission.insertCourse; //เพิ่มคอร์ส
            // this.updateCourse = result.permission.updateCourse; //แก้ไขคอร์ส
            // this.activeCourse = result.permission.activeCourse; //ระงับคอร์ส

            // this.manageCategory = result.permission.viewCategory; //จัดการ Category

            // this.manageBanner = result.permission.viewBanner; //จัดการ banner

            // this.viewReport = result.permission.viewReport; //เข้าถึงการรายงาน

            // this.userGroup = result.permission.viewUserGroup; //จัดการกลุ่มผู้ใช้
            // this.adminCompany = result.permission.adminCompany;
            // this.notification = result.permission.notification;

            // defind permission by Role
            if (result.permission.adminCompany) {
                this.selectedRoleType = 'Administrator'
                console.log(this.selectedRoleType);
            } else if (result.isTeacher == 'y') {
                this.selectedRoleType = 'Instructor'
            } else {
                this.selectedRoleType = 'Learner'
            }
        },

        async insertOrUpdateUserGroup() {
            let result = await addUserGroup({
                id: this.editUserId,
                // user_groups: groupId.filter((id, index) => groupId.indexOf(id) == index)
                // user_groups: []
                user_groups: this.selection,
            });
            if (result.code != 200) {
                this.dialogUserGroupSuccess = true;
                // let oldPage = this.page
                await this.getUserList();
                // this.page = oldPage
            }
        },

        async previewImportStudent(excelData, header) {
            let arrayusername = [];
            excelData.forEach((element) => {
                arrayusername.push({
                    email: element.contactEmail,
                    username: element.username,
                });
            });
            let data = {
                company: this.$store.state.company._id,
                arrayusername: arrayusername,
            };
            let result = await preview(data); //check duplicate user api


            this.arrFeildHeader = [];
            this.canImporting2 = true;
            console.log("previewImportStudent -> this.tem_tableHeader_password", this.tem_tableHeader_password)
            for (let indexheader = 0; indexheader < header.length; indexheader++) {
                if (this.fix_password == "custom") {
                    let findHeader = this.tableHeader_password.find(
                        (x) => x.value == header[indexheader]
                    );
                    if (!findHeader) {
                        //เงื่อนไขถ้าผู้ใช้สร้างหัวฟิลด์ใหม่เพิ่มเป็นเมตาดาต้า
                        let resultCheck = await this.checkKeyMetadata(header[indexheader]);
                        if (resultCheck == true) {
                            this.arrFeildHeader.push({
                                key: header[indexheader],
                            });
                            this.tableHeader_password.push({
                                sortable: false,
                                text: header[indexheader],
                                value: header[indexheader],
                            });
                            this.countHeader += 1;
                        } else {
                            this.canImporting2 = false;
                            this.rejectDialog = true;
                        }
                    }
                } else {
                    let findHeader = this.tableHeader.find((x) => x.value == header[indexheader]);

                    if (!findHeader) {
                        let resultCheck = await this.checkKeyMetadata(header[indexheader]);

                        if (resultCheck == true) {
                            this.arrFeildHeader.push({
                                key: header[indexheader],
                            });
                            this.tableHeader.push({
                                sortable: false,
                                text: header[indexheader],
                                value: header[indexheader],
                            });
                        } else {
                            this.canImporting2 = false;

                            this.rejectDialog = true;
                        }
                    }
                }
            }


            console.log("previewImportStudent -> this.arrFeildHeader", this.arrFeildHeader)
            console.log("previewImportStudent -> excelData", excelData)
            this.userUploadRepeat = [];
            this.userUploadSuccess = [];
            if (result) {
                this.showExampleTable = false;
                this.showTabsResult = true;
                for (let i = 0; i < result.student_accept.length; i++) {
                    excelData.forEach(async (user) => {
                        if (result.student_accept[i] === user.contactEmail) {
                            let arrObjMetadata = [];
                            this.arrFeildHeader.forEach(async (metafeild) => {
                                let obj = {
                                    key: metafeild.key,
                                    value: user[metafeild.key],
                                };
                                await arrObjMetadata.push(obj);
                            });

                            await this.userUploadSuccess.push({
                                ...user,
                                metaData: arrObjMetadata,
                            });
                        }
                    });
                }
                for (let i = 0; i < result.student_duplicate.length; i++) {
                    excelData.forEach(async (user) => {
                        if (
                            result.student_duplicate[i].email === user.email ||
                            result.student_duplicate[i].username === user.username
                        ) {
                            let arrObjMetadata = [];
                            this.arrFeildHeader.forEach(async (metafeild) => {
                                let obj = {
                                    key: metafeild.key,
                                    value: user[metafeild.key],
                                };
                                await arrObjMetadata.push(obj);
                            });

                            await this.userUploadRepeat.push({
                                student: result.student_duplicate[i],
                                ...user,
                                metaData: arrObjMetadata,
                            });
                        }
                    });
                }
            }

            this.tableData = excelData;

            console.log("previewImportStudent -> this.userUploadSuccess", this.userUploadSuccess)

            console.log("previewImportStudent -> this.userUploadRepeat", this.userUploadRepeat)
            this.arrayGroupTitle = [];
            let wrongusergroup = false;
            this.userUploadSuccess.forEach((data, index) => {
                let setbool = 0;
                let arrId = [];
                this.arrWrongGroup = [];
                let setTitle = [];
                if (data.usergroups) {
                    if (this.userUploadSuccess[index].usergroups.toString().includes(",")) {
                        arrId = this.userUploadSuccess[index].usergroups.toString().split(",");
                        for (let indexs = 0; indexs < arrId.length; indexs++) {
                            let findId = this.arrayGroup.find((x) => x._id == arrId[indexs]);
                            if (findId) {
                                setTitle.push({
                                    _id: findId._id,
                                    title: findId.title,
                                });
                            } else {
                                this.canImporting = false;
                                this.arrWrongGroup.push({
                                    _id: arrId[indexs],
                                });
                            }
                        } // for loop

                        setbool += 1;
                        let obj = {
                            groupWrong: this.arrWrongGroup ? this.arrWrongGroup : [],
                            groupTitle: setTitle,
                            ...this.userUploadSuccess[index],
                        };
                        this.userUploadSuccess[index] = obj;
                    }

                    this.arrayGroup.forEach((group) => {
                        if (data.usergroups == group._id) {
                            setbool += 1;
                            let obj = {
                                groupTitle: [
                                    {
                                        id: group._id,
                                        title: group.title,
                                    },
                                ],
                                ...this.userUploadSuccess[index],
                            };
                            this.userUploadSuccess[index] = obj;
                        }
                    });

                    if (setbool == 0) {
                        this.canImporting = false;
                        wrongusergroup = true;
                        let obj = {
                            wrong: true,
                            groupTitle: "",
                            ...this.userUploadSuccess[index],
                        };
                        this.userUploadSuccess[index] = obj;
                    }
                } else {
                    setbool = 1;
                    let obj = {
                        groupTitle: "",
                        ...this.userUploadSuccess[index],
                    };
                    this.userUploadSuccess[index] = obj;
                }

                if (setbool > 0 && this.arrWrongGroup.length == 0 && !wrongusergroup) {
                    this.canImporting = true;
                }
            });
            await this.showGroupList(this.arrayGroupTitle);

            this.arrayGroupTitleRepeat = [];
            this.userUploadRepeat.forEach((data, index) => {
                let setbool = 0;
                let arrId = [];
                if (data.usergroups) {
                    if (this.userUploadRepeat[index].usergroups.toString().includes(",")) {
                        arrId = this.userUploadRepeat[index].usergroups.toString().split(",");
                        this.arrWrongGroupRepeat = [];
                        for (let indexs2 = 0; indexs2 < arrId.length; indexs2++) {
                            let findId = this.arrayGroup.find((x) => x._id == arrId[indexs2]);
                            if (findId) {
                                this.arrayGroupTitleRepeat.push({
                                    _id: findId._id,
                                    title: findId.title,
                                });
                            } else {
                                this.canImporting = false;
                                this.arrWrongGroupRepeat.push({
                                    _id: arrId[indexs2],
                                });
                            }
                        } // for loop

                        setbool += 1;
                        let obj = {
                            groupWrong: this.arrWrongGroupRepeat ? this.arrWrongGroupRepeat : [],
                            groupTitle: this.arrayGroupTitleRepeat,
                            ...this.userUploadRepeat[index],
                        };
                        this.userUploadRepeat[index] = obj;
                    }

                    this.arrayGroup.forEach((group) => {
                        if (data.usergroups == group._id) {
                            setbool += 1;
                            let obj = {
                                groupTitle: [
                                    {
                                        id: group._id,
                                        title: group.title,
                                    },
                                ],
                                ...this.userUploadRepeat[index],
                            };
                            this.userUploadRepeat[index] = obj;
                        }
                    });

                    if (setbool == 0) {
                        let obj = {
                            wrong: true,
                            groupTitle: "",
                            ...this.userUploadRepeat[index],
                        };
                        this.userUploadRepeat[index] = obj;
                    }
                } else {
                    setbool = 1;
                    let obj = {
                        groupTitle: "",
                        ...this.userUploadRepeat[index],
                    };
                    this.userUploadRepeat[index] = obj;
                }
            });
            await this.showGroupList(this.arrayGroupTitleRepeat);
            // this.showExampleTable = true;
        },
        async uploadUser() {
            console.log(this.userUploadSuccess);
            console.log(this.arrFeildHeader);
            if (this.userUploadSuccess.length > 0) {
                this.loadingReturn = true;
                let arrayusername = [];
                await this.userUploadSuccess.forEach(async (element, index) => {
                    await arrayusername.push({
                        email: element.contactEmail ? element.contactEmail : null,
                        username: element.username ? element.username : null,
                        prefix: element.prefix,
                        firstName: element.firstname ? element.firstname : null,
                        lastName: element.lastname ? element.lastname : null,
                        gender:
                            element.gender == "ชาย" || element.gender == "ช"
                                ? "male"
                                : element.gender == "หญิง" || element.gender == "ญ"
                                    ? "female"
                                    : null,
                        studentCode: "",
                        identificationNumber: "",
                        school: element.note,
                        password: element.password ? element.password : null,
                        user_groups: element.usergroups,
                        // metaData: element.metaData,
                    });
                });

                let success = true;
                let i, j, temparray, chunk = 300;
                for (i = 0, j = arrayusername.length; i < j; i += chunk) {
                    temparray = arrayusername.slice(i, i + chunk);
                    // do whatever
                    let data = {
                        // usergroup: this.userGroupSearch2,
                        company: this.$store.state.company._id,
                        isgenpassword: this.fix_password == "custom" ? false : true,
                        arrayusername: temparray,
                        issendemail: this.fix_password == "custom" ? false : true,
                    };

                    let result = await importStudent(data);
                    if (result.code) {
                        success = false;
                        break;
                        // this.loadingReturn = false;
                    }
                }
                if (success) {
                    this.loadingReturn = false;
                }
            }
            return true;
        },
        async updateUserByDuplicate() {
            // // console.log(this.userUploadRepeat);
            if (this.userUploadRepeat.length > 0) {
                for (let element of this.userUploadRepeat) {
                    // await this.userUploadRepeat.forEach(async element => {
                    let data = {
                        idstudent: element.student._id ? element.student._id : "",
                    };
                    // data = element.email ? {...data, email:element.email} : data
                    // data = element.username ? {...data, username:element.username} : data
                    // data = element.metaData
                    //   ? {
                    //       ...data,
                    //       metaData: element.metaData,
                    //     }
                    //   : data;
                    data = element.prefix
                        ? {
                            ...data,
                            prefix: element.prefix,
                        }
                        : data;
                    data = element.firstname
                        ? {
                            ...data,
                            firstName: element.firstname,
                        }
                        : data;
                    data = element.lastname
                        ? {
                            ...data,
                            lastName: element.lastname,
                        }
                        : data;
                    data = element.gender
                        ? {
                            ...data,
                            gender:
                                element.gender == "ชาย" || element.gender == "ช"
                                    ? "male"
                                    : element.gender == "หญิง" || element.gender == "ญ"
                                        ? "female"
                                        : null,
                        }
                        : data;
                    data = element.studentCode
                        ? {
                            ...data,
                            studentCode: element.studentCode,
                        }
                        : data;
                    data = element.identificationNumber
                        ? {
                            ...data,
                            identificationNumber: element.identificationNumber,
                        }
                        : data;
                    // // console.log(element["organization(optional)"]);
                    data = element["organization(optional)"]
                        ? {
                            ...data,
                            school: element["organization(optional)"],
                        }
                        : data;
                    data = element.birthdate
                        ? {
                            ...data,
                            birthdate: element.birthdate,
                        }
                        : data;
                    console.log(data);

                    await editProfileByID(data);
                    // });
                }
                return true;
            }
            return true;
        },
        async uploadFile() {
            this.successUpload = false;

            await this.uploadUser();
            // update User
            await this.updateUserByDuplicate();
            //
            // // console.log(result)
            // if (resultUpload) {
            // // console.log(result)
            await this.closeExcelDialog();
            await this.getUserList();
            // }
            this.successUpload = true;
        },

        checkPermission() {
            return (
                this.$store.state.permission.insertStudent == true ||
                this.$store.state.permission.updateStudent == true
            );
        },

        async checkKeyMetadata(key) {
            console.log(key);
            // key = key
            //   .replace(new RegExp("\\(", "g"), "_")
            //   .replace(new RegExp("\\)", "g"), "_");
            // console.log(key);
            // if (key.match(/[\u2000-\u206F\u2E00-\u2E7F]/g)) {
            //   // ดักอักขระพิเศษ
            //   // console.log(1);
            //   return true;
            // }
            if (key.match(new RegExp("^[a-zA-Z_]+$", "g"))) {
                // ใช้ได้เฉพาะตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ พิมพ์เล็ก และขีดล่างเท่านั้น เข้า if สามารถใช้ได้
                // console.log(2);
                return true;
            }
            // if (key.match(new RegExp(" ", "g"))) {
            //   // ดักเว้นวรรค
            //   // console.log(3);
            //   return true;
            // }
            // if (key.match(new RegExp(/(\r\n|\n|\r)/gm, "g"))) {
            //   // ดักเว้นวรรค \r
            //   // console.log(4);
            //   return true;
            // }
            else {
                // console.log(5);
                return false;
            }
        },

        async insertOrUpdateUser() {
            this.$refs.form.validate();
            let arrCheckMetaData = [];
            for (let index = 0; index < this.arrMetaData.length; index++) {
                const element = this.arrMetaData[index];
                if (element.key) {
                    let resultCheck = await this.checkKeyMetadata(element.key);
                    // // console.log(resultCheck);
                    if (resultCheck == false) {
                        arrCheckMetaData.push(index);
                    }
                } else {
                    // // console.log("delete");
                    await this.confirmDeleteRowData(index);
                }
            }
            // // console.log(arrCheckMetaData);
            if (arrCheckMetaData.length > 0) {
                this.dialogAddMetaDataFail = true;
            } else {
                console.log(this.resultPermission)
                if (this.isEdit == true) {
                    if (this.imgPreview) {
                        this.preview();
                    }
                    if (this.checkIsTeacher == true) {
                        this.isTeacher = "y";
                    }
                    // // console.log(this.isTeacher);
                    let status = await updateUser({
                        ...this.oldDetailUser,
                        id: this.editUserId,
                        companies: this.editUserCompanies,
                        image: this.imgPreview,
                        prefix: this.prefixName,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        school: this.school,
                        gender: this.selectedGender,
                        email: this.email,
                        username: this.username.trim(),
                        password: this.password,
                        isTeacher: this.isTeacher,
                        user_groups: this.selection,
                        description: this.description == "" || this.description == " " ? null : this.description,
                        permission: {
                            viewTutor: false,
                            viewStudent: this.viewStudent, //ข้อมูลผู้ใช้
                            insertStudent: this.insertStudent, //เพิ่มรายชื่อ
                            updateStudent: this.updateStudent, //แก้ไขรายชื่อผู้ใช้
                            activeStudent: this.activeStudent, //ระงับการใช้งาน

                            viewCourse: this.viewCourse, //เข้าถึงคอร์ส
                            insertCourse: this.insertCourse, //เพิ่มคอร์ส
                            updateCourse: this.updateCourse, //แก้ไขคอร์ส
                            activeCourse: this.activeCourse, //ระงับคอร์ส

                            viewCategory: this.manageCategory, //จัดการ Category
                            insertCategory: this.manageCategory, //จัดการ Category
                            updateCategory: this.manageCategory, //จัดการ Category
                            activeCategory: this.manageCategory, //จัดการ Category

                            viewBanner: this.manageBanner, //จัดการ Banner
                            insertBanner: this.manageBanner, //จัดการ Banner
                            updateBanner: this.manageBanner, //จัดการ Banner
                            activeBanner: this.manageBanner, //จัดการ Banner

                            viewReport: this.viewReport, //เข้าถึงการรายงาน

                            viewCompany: false,
                            insertCompany: false,
                            updateCompany: false,
                            activeCompany: false,

                            viewUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
                            insertUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
                            updateUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
                            activeUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้

                            accessBI: false,

                            adminCompany: this.adminCompany, //อนุญาตให้เป็นแอดมิน
                            notification: this.notification, //เข้าถึงเมนูส่งการแจ้งเตือน
                        },
                        localizations: [
                            {
                                prefix: this.prefixName,
                                firstName: this.firstName,
                                lastName: this.lastName,
                                lang: "th",
                            },
                            {
                                prefix: this.prefixNameEng,
                                firstName: this.firstNameEng,
                                lastName: this.lastNameEng,
                                lang: "en",
                            },
                        ],
                        // metaData: this.arrMetaData,
                    });
                    // return status
                    //ตอนนี้มี error อันเดียว คือ usernameซ้ำเลยใช้ if 403
                    // if (status.code != 200) {
                    //   this.dialogEditSuccess = true;
                    //   this.getUserList();
                    // } else {
                    //   this.dialogEditFail = true; //กรณี error อื่น
                    //   this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    // }
                    if (status.message == "username or email duplicade") {
                        this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    } else if (status.code == 403) {
                        this.dialogEditFail = true; //กรณี error อื่น
                    } else {
                        this.dialogEditSuccess = true;
                        this.clearForm();
                        this.getUserList();
                    }
                } else {
                    if (
                        this.$store.state.permission.insertStudent == true ||
                        this.$store.state.permission.updateStudent == true
                    ) {
                        if (this.checkIsTeacher == true) {
                            this.isTeacher = "y";
                        } else {
                            this.isTeacher = "n";
                        }
                    }
                    let status = await register({
                        companies: JSON.parse(localStorage.getItem("company")).companies[0]._id,
                        image: this.imgURL,
                        prefix: this.prefixName,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        school: this.school,
                        gender: this.selectedGender,
                        email: this.email,
                        username: this.username.trim(),
                        password: this.password,
                        isTeacher: this.isTeacher,
                        user_groups: this.selection,
                        isgenpassword: this.checkboxPasswordSendMail,
                        description: this.description == "" || this.description == " " ? null : this.description,
                        permission: {
                            viewTutor: false,
                            viewStudent: this.viewStudent, //ข้อมูลผู้ใช้
                            insertStudent: this.insertStudent, //เพิ่มรายชื่อ
                            updateStudent: this.updateStudent, //แก้ไขรายชื่อผู้ใช้
                            activeStudent: this.activeStudent, //ระงับการใช้งาน

                            viewCourse: this.viewCourse, //เข้าถึงคอร์ส
                            insertCourse: this.insertCourse, //เพิ่มคอร์ส
                            updateCourse: this.updateCourse, //แก้ไขคอร์ส
                            activeCourse: this.activeCourse, //ระงับคอร์ส

                            viewCategory: this.manageCategory, //จัดการ Category
                            insertCategory: this.manageCategory, //จัดการ Category
                            updateCategory: this.manageCategory, //จัดการ Category
                            activeCategory: this.manageCategory, //จัดการ Category

                            viewBanner: this.manageBanner, //จัดการ Banner
                            insertBanner: this.manageBanner, //จัดการ Banner
                            updateBanner: this.manageBanner, //จัดการ Banner
                            activeBanner: this.manageBanner, //จัดการ Banner

                            viewReport: this.viewReport, //เข้าถึงการรายงาน

                            viewCompany: false,
                            insertCompany: false,
                            updateCompany: false,
                            activeCompany: false,

                            viewUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
                            insertUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
                            updateUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้
                            activeUserGroup: this.userGroup, //จัดการกลุ่มผู้ใช้

                            accessBI: false,

                            adminCompany: this.adminCompany, //อนุญาตให้เป็นแอดมิน
                            notification: this.notification, //เข้าถึงเมนูส่งกา��แจ้งเตือน
                        },
                        localizations: [
                            {
                                prefix: this.prefixName,
                                firstName: this.firstName,
                                lastName: this.lastName,
                                lang: "th",
                            },
                            {
                                prefix: this.prefixNameEng,
                                firstName: this.firstNameEng,
                                lastName: this.lastNameEng,
                                lang: "en",
                            },
                        ],
                        // metaData: this.arrMetaData,
                    });
                    if (this.checkboxPasswordSendMail == true) {
                        let result = await registerSendMail({
                            companies: JSON.parse(localStorage.getItem("company")).companies[0]._id,
                            email: this.email,
                        });
                        // // console.log(result);
                    }

                    if (status.message == "username or email duplicade") {
                        this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    } else if (status.code == 403) {
                        this.dialogAddFail = true; //กรณี error อื่น
                    } else {
                        this.dialogAddSuccess = true;
                        // this.getUserList();
                        this.clearForm();
                        this.initialize();
                    }
                    return status;
                }
            }
        },
        async exportStudent() {
            const result = await getUserList({
                ...this.params,
                limit: 0,
                page: 1,
            });
            return result.data;
        },
        importStudent() {
            this.excelDialog = true;
            this.canImporting = false;
        },
        closeExcelDialog() {
            this.excelDialog = false;
            this.tableData = [];
            this.showExampleTable = true;
            this.showTabsResult = false;
            this.userUploadFail = [];
            this.userUploadRepeat = [];
            this.userUploadSuccess = [];
            // this.userGroupSearch2 = null;
            this.userGroupSearch2 = [];
            this.tabResult = "success";
            this.isSuccessTab = true;
            this.loadingReturn = false;
        },
        async userEdit(item) {
            this.dialogFormUser = true;
            this.imageReady = true;
            if (item != null) {
                console.log(item);
                this.isEdit = true;
                this.getUserEdit(item);
                this.checkboxPassword = false;
                this.checkboxPasswordHide = true;
                // this.imageReady = true;
            } else {
                console.log("! item");

                this.isEdit = false;
                this.tab = 0;
                this.checkboxPassword = true;
                this.checkboxPasswordHide = false;

                // this.imageReady = true;
                this.prefixName = "";
                this.firstName = "";
                this.lastName = "";
                this.school = "";
                this.email = "";
                this.username = "";
                this.password = "";
                this.conFirmPassword = "";
                this.image = "";
                this.imgPreview = "";
                this.selectedGender = null;
                this.selection = [];
                this.description = null;
                this.editUserId = null;

                this.imageFile = null;
                // this.viewStudent = false; //ข้อมูลผู้ใช้
                // this.insertStudent = false; //เพิ่มรายชื่อ
                // this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
                // this.activeStudent = false; //ระงับการใช้งาน

                // this.checkIsTeacher = false;

                // this.viewCourse = false; //เข้าถึงคอร์ส
                // this.insertCourse = false; //เพิ่มคอร์ส
                // this.updateCourse = false; //แก้ไขคอร์ส
                // this.activeCourse = false; //ระงับคอร์ส

                // this.manageCategory = false; //จัดการ Category

                // this.manageBanner = false; //จัดการ Banner

                // this.viewReport = false; //เข้าถึงการรายงาน

                // this.userGroup = false; //จัดการกลุ่มผู้ใช้
                // this.adminCompany = false;
                // this.notification = false;

                this.prefixNameEng = "";
                this.firstNameEng = "";
                this.lastNameEng = "";

                this.arrMetaData = [];

                this.selectedRoleType = 'Learner'
            }
            this.$refs.form.resetValidation();
        },

        async requestTutor() {
            this.dialogRequestTutor = true;
            //TODO ต่อ api ยื่นหลักฐาน
            // let status = await register({
            //     image: [
            //     ],
            //     firstName: this.firstName,
            //     lastName: this.lastName,
            //     gender: this.selectedGender,
            //     email: this.email,
            //     username: this.username,
            //     password: this.password,
            //   });
            //   // console.log(status)
        },

        clearForm() {
            this.dialogFormUser = false;
            this.isEdit = false;
            this.tab = 0;
            this.checkboxPassword = false;
            this.checkboxPasswordSendMail = false;
            this.checkboxPasswordHide = false;

            // this.insertStudent = false; //เพิ่มรายชื่อ
            // this.updateStudent = false; //แก้ไขรายชื่อผู้ใช้
            // this.activeStudent = false; //ระงับการใช้งาน

            // this.viewCourse = false; //เข้าถึงคอร์ส
            // this.insertCourse = false; //เพิ่มคอร์ส
            // this.updateCourse = false; //แก้ไขคอร์ส
            // this.activeCourse = false; //ระงับคอร์ส

            // this.manageCategory = false; //จัดการ Category

            // this.manageBanner = false; //จัดการ Banner

            // this.viewReport = false; //เข้าถึงการรายงาน

            // this.userGroup = false; //จัดการกลุ่มผู้ใช้

            // this.adminCompany = false;

            this.selectedRoleType = null;

            this.prefixName = "";
            this.firstName = "";
            this.lastName = "";
            this.school = "";
            this.email = "";
            this.username = "";
            this.password = "";
            this.conFirmPassword = "";
            this.image = "";
            this.imgPreview = "";
            this.imgURL = "";
            this.imageFile = null;

            this.viewStudent = false; //ข้อมูลผู้ใช้
            this.prefixNameEng = "";
            this.firstNameEng = "";
            this.lastNameEng = "";
            this.arrMetaData = [];
            this.description = null;
            this.editUserId = null;

            this.$refs.form.resetValidation();
        },

        async userUpdateActive() {
            if (this.updateActive == true) {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: false,
                });
                this.dialogStatus = false;
                this.dialogSuccess = true;
                this.getUserList();
                return status;
            } else {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: true,
                });
                this.dialogStatusActive = false;
                this.dialogSuccess = true;
                this.getUserList();
                return status;
            }
        },
        noPermission() {
            this.alert = true;
        },
        deleteUserDialog() {
            this.delete_dialog = true;
        },
        closeUserDialog() {
            this.initialize();
            this.delete_dialog = false;
        },
        getRole(permission) {
            // defind permission by Role
            if (permission.adminCompany) {
                return 'Administrator'
            } else if (permission.isTeacher == 'y') {
                return 'Instructor'
            } else {
                return 'Learner'
            }
        },
        async exportReport(item){
            let result = await exportReport({studentId: item.id});
            let courseReport = []

            courseReport = [
                ["Username", result.username],
                ["First name", result.firstName],
                ["Last name", result.lastName],
                ["Email", result.email],
                [],
                [],
                []
            ]
            for(let course of result.history){
                let courseName = ["Course Name", course.title]
                let header = []
                let detail = []
                let percent = 0
                for(let lecture of course.lecture){
                    header.push(lecture.title+'(%)')
                    detail.push(lecture.percent)
                    percent += lecture.percent
                }
                header.push('Total(%)')
                detail.push(course.percent)
                courseReport.push(courseName, header, detail, [], [], [])
            }
            await this.generatExcel(courseReport, item)
           
        },
        async generatExcel(report, student){

            const dataWS = XLSX.utils.aoa_to_sheet(report);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS);
            // XLSX.writeFile(wb, this.course_info + `_` + `ExamReport` + `.xlsx`);
            XLSX.writeFile(wb, student.username + `.xlsx`);

        },
        closeWrongTemplateDialog(){
            this.wrongTemplateDialog = false
        },
        closePasswordLessthanDialog(){
            this.passwordLessthanDialog = false
        }
    },
    created() {
        const self = this;
        this.users.map((item) => {
            if (item.active) self.disabledCount += 1;
        });
    },
};